function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 = /*#__PURE__*/React.createElement("g", {
  fill: "none",
  fillRule: "evenodd"
}, /*#__PURE__*/React.createElement("g", {
  fill: "#36C"
}, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
  d: "M8.157 2c.344 0 .671.148.9.406l1.692 1.917c.162.182.251.418.251.662v8.163c0 .47-.381.852-.852.852H1.852c-.47 0-.852-.381-.852-.852V2.852c0-.47.381-.852.852-.852h6.305zM8.7 9.09H3.3c-.166 0-.3.135-.3.3v1.037c0 .166.134.3.3.3h5.4c.166 0 .3-.134.3-.3V9.391c0-.166-.134-.3-.3-.3zm0-3.817H3.3c-.166 0-.3.134-.3.3v1.036c0 .166.134.3.3.3h5.4c.166 0 .3-.134.3-.3V5.573c0-.166-.134-.3-.3-.3z",
  transform: "translate(-537.000000, -1813.000000) translate(440.000000, 1728.000000) translate(96.000000, 83.000000)"
})))));

var SvgDoclink = function SvgDoclink(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 10,
    height: 12,
    viewBox: "0 0 10 12",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _ref2);
};

var ForwardRef = React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgDoclink, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/doclink.62f899f4.svg";
export { ForwardRef as ReactComponent };